import { environment } from '../../environments/environment';

export interface DefaultConfiguration {
  language: string;
  logoSrc: string;
  title: string;
  faviconLocation: string;
}

export function getDefaultConfiguration(): DefaultConfiguration {
  const defaultConfig: DefaultConfiguration = {
    language: 'se',
    logoSrc: '',
    title: '',
    faviconLocation: ''
  };

  if (environment.projectName === 'ref') {
    defaultConfig.language = 'en';
    defaultConfig.logoSrc = './assets/REF_Logo_White.png';
    defaultConfig.title = 'Ref';
    defaultConfig.faviconLocation = './assets/favicon-ref';
  } else if (environment.projectName === 'capstone') {
    defaultConfig.language = 'se';
    defaultConfig.logoSrc = './assets/logo_capstone.png';
    defaultConfig.title = 'Capstone';
    defaultConfig.faviconLocation = './assets/favicon-capstone';
  }

  return defaultConfig;
}
